<template>
  <div>
    <div class="app-main__inner">
      <TituloComponente
        icono-titulo="fas fa-plus"
        texto-titulo="Nueva Modalidad Contratacion"
      />
      <div class="tab-content">
        <div
          class="tab-pane tabs-animation fade show active"
          id="tab-content-0"
          role="tabpanel"
        >
          <div class="row">
            <div class="col-lg-12">
              <div class="main-card mb-3 card">
                <div class="card-body">
                  <h5 class="card-title">Datos:</h5>
                  <form @submit.prevent="guardarModalidadContratacion()">
                    <float-label label="Código:" clase>
                      <input
                        v-model="modalidadContratacion.codigo"
                        id="codigo"
                        placeholder="Ingresar un código..."
                        type="text"
                        class="form-control"
                        :class="
                          enviado && !$v.modalidadContratacion.codigo.required
                            ? 'is-invalid'
                            : ''
                        "
                      />
                      <template v-slot:validation>
                        <div
                          class="invalid-feedback"
                          v-if="
                            enviado && !$v.modalidadContratacion.codigo.required
                          "
                        >
                          Debe ingresar un código
                        </div>
                      </template>
                    </float-label>
                    <float-label label="Descripción:" clase="">
                      <input
                        id="descripcion"
                        v-model="modalidadContratacion.descripcion"
                        placeholder="Ingresar una descripción..."
                        type="text"
                        class="form-control"
                      />
                    </float-label>
                    <button class="mt-1 btn btn-info float-right">
                      Guardar
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponente from "@/components/layouts/TituloComponente";
import { required } from "vuelidate/lib/validators";
import FloatLabel from "@/components/layouts/FloatLabel";
import ModalidadContratacion from "@/models/modalidadContratacion";
import axios from "axios";
export default {
  name: "NuevaModalidadContratacion",
  components: {
    TituloComponente,
    FloatLabel,
  },
  data() {
    return {
      modalidadContratacion: new ModalidadContratacion(null, "", ""),
    };
  },
  validations: {
    modalidadContratacion: {
      codigo: { required },
      descripcion: { required },
    },
  },
  methods: {
    guardarModalidadContratacion() {
      axios
        .post("/modalidadcontratacion", this.modalidadContratacion)
        .then((res) => {
          if (res.data.success) {
            this.$router.push({ name: "ListarModalidadContrataciones" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
      console.log(this.modalidadContratacion);
    },
  },
};
</script>